import axios from 'axios';
import type { ApiResponse } from '../types/api';
import { api } from './client';

export interface UploadUrlResponse {
  signedUrl: string;
  token: string;
  path: string;
}

export const uploadService = {
  /**
   * Get a signed URL for uploading a file
   */
  getUploadUrl: async (
    filename: string,
    module: string,
    contentType: string,
  ): Promise<ApiResponse<UploadUrlResponse>> => {
    const response = await api.post<ApiResponse<UploadUrlResponse>>(
      '/resources/upload-url',
      {
        filename,
        module,
        contentType,
      },
    );
    return response;
  },

  /**
   * Upload file to the signed URL using PUT
   */
  uploadFileToUrl: async (
    signedUrl: string,
    file: File,
    contentType: string,
    onProgress?: (progress: number) => void,
  ): Promise<void> => {
    try {
      await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': contentType,
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total && onProgress) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            onProgress(percentCompleted);
          }
        },
      });
    } catch (error: any) {
      throw new Error(
        `Upload failed: ${error.response?.status} ${JSON.stringify(
          error.response?.data,
        )}`,
      );
    }
  },
};
